module.exports = __webpack_public_path__ + "fonts/bootstrap-icons.c5787b4a.woff2";